import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import SearchInput from "../../../components/SerachInput";
import { fetchLanguageList, updateLanguageList } from "../../../slices/panelSlice/languageSlice";
import { fetchPageHeaderData, updatePageHeaderData } from "../../../slices/panelSlice/pageHeaderSlice";


function PageHeaderTranslation({ currLang, langList, editable }) {
  const dispatch = useDispatch();
  const [translation, setTranslation] = useState({});
  const [filteredLangList, setFilteredLangList] = useState(langList);

  useEffect(()=>{

  })

  useEffect(() => {
    setTranslation({ ...currLang.data }); // Initialize translation state
    setFilteredLangList(langList); // Initialize filtered list
  }, [currLang, langList]);


  const removeEmptyKeys = (obj)=>{
    // Create a new object to store non-empty keys 
    const cleanedObj = {};
    // Iterate over the object keys
    for (const key in obj) {
        // Check if the key has a non-empty value
        if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
            cleanedObj[key] = obj[key];
        }
    }

    return cleanedObj;
}
  const updateTranslation = async () => {
   const finalTrans =  removeEmptyKeys(translation);
   let data = {
    id:currLang.id,
    translate:finalTrans
   }
   const updateResp = await dispatch(updatePageHeaderData(data));
   await dispatch(fetchPageHeaderData());
   console.log(updateResp)

  };

  const handleTransChange = (e) => {
    const { name, value } = e.target;
    setTranslation((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <SearchInput
        placeholder="Search for a language..."
        data={langList}
        onSearchResults={setFilteredLangList} // Update filtered list in parent
      />
      <div className="overflow-y-scroll h-56 p-4 pr-10 thin-scrollbar">
        {filteredLangList?.map((m) => (
          <div className="flex justify-between mt-2 min-w-[45%] ml-5" key={m.title}>
            <div className="mr-2">{m.title}</div>
            <input
              type="text"
              className="h-8"
              onChange={handleTransChange}
              name={m.title}
              value={translation[m.title] || ""}
            />
          </div>
        ))}
      </div>
      {editable && <button
        onClick={updateTranslation}
        className="mt-4 bg-[var(--mainCol)] text-white p-2 rounded-md"
      >
        Update Translation <FontAwesomeIcon className="ml-2" icon={faArrowsRotate} />
      </button>}
    
    </>
  );
}

export default PageHeaderTranslation;
